export default "__VITE_ASSET__CZipuRqI__"